module.exports = __webpack_public_path__ + "prj_05.4cfc5277.jpeg";